import { useEffect } from 'react'
import { UserSocialProfile } from '../redux/slices/userSlice'
import { API } from './API'
import { LoginProvider } from './LoginProvider'
import { useTranslation } from '../hooks/useTranslation'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { closeModal } from '../redux/slices/modalSlice'
import { useNavigate } from 'react-router'

const LoginFB: React.FC = () => {
	const dispatch = useAppDispatch()
	const { getTexts } = useTranslation(false)
	const {
		modalProps: { routing, deeplink },
	} = useAppSelector((state) => state.modal)
	const navigate = useNavigate()

	useEffect(() => {
		console.log('LoginFB, component created, checking login status')
		if (window.FB) {
			FB.getLoginStatus(getLoginStatusResponse)
		} else {
			;(window as any).FBLoaded = () => FB.getLoginStatus(getLoginStatusResponse)
		}
	})

	const getUserInfo = (userId: string, token: string) => {
		console.log('LoginFB, getUserInfo for user:', userId)
		FB.api('/me', { fields: ['id', 'name', 'first_name', 'last_name', 'short_name', 'email'] }, async (response: any) => {
			console.log('LoginFB, getUserInfo response', response)
			if (response && response.id) {
				const profile: UserSocialProfile = {
					firstName: response.first_name,
					lastName: response.last_name,
					name: response.short_name,
					picture: `https://graph.facebook.com/${response.id}/picture?width=200&height=200`,
					original: response,
				}

				await API.processSocialLogin(LoginProvider.FB, userId, token, response.email, profile)
				routing && navigate(routing.pathname)
				deeplink && deeplink()
				dispatch(closeModal())
			}
		})
	}

	const getLoginStatusResponse = (r: any) => {
		console.log('LoginFB, getLoginStatusResponse:', r)
		if (r.status === 'connected') {
			getUserInfo(r.authResponse.userID, r.authResponse.accessToken)
		}
	}

	const doLogin = () => {
		FB.login((r) => FB.getLoginStatus(getLoginStatusResponse), {
			auth_type: 'rerequest',
			scope: 'email',
		})
	}

	return (
		<>
			<div className="fb-button" onClick={doLogin}>
				<div className="fb-icon"></div>
				{getTexts('loginButtonFB')}
			</div>
		</>
	)
}

export { LoginFB }
